import {Route, Routes} from 'react-router-dom';

import {hasAdminPermission} from '@afriex/core/utils';

import Layout from './components/common/Layout';
import SpinningLoader from './components/common/SpinningLoader';
import RequireAuth from './components/RequireAuth';
import {privateRoutesConfig, publicRoutesConfig} from './config/routesConfig';
import TransactionProvider from './context/TransactionProvider';
import {useAuth} from './hooks/useAuth';
import HomePage from './pages/HomePage';
import PageNotFoundPage from './pages/PageNotFoundPage';

export default function RouteNodes() {
  const {role, authLoading} = useAuth();

  // Show a loading spinner while checking authentication status
  if (authLoading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <SpinningLoader size={14} />
      </div>
    );
  }

  return (
    <Routes>
      {/* public Routes */}
      {publicRoutesConfig.map(({path, Component}) => (
        <Route path={path} element={<Component />} key={path} />
      ))}

      {/* Private Routes — admin layout */}
      <Route
        path="/"
        element={
          <TransactionProvider>
            <RequireAuth>
              <Layout />
            </RequireAuth>
          </TransactionProvider>
        }
      >
        <Route index element={<HomePage />} />
        {privateRoutesConfig.map(({path, permission, Component}) => {
          const found = !permission || hasAdminPermission(role, permission);
          return (
            found && <Route path={path} element={<Component />} key={path} />
          );
        })}
        <Route path="*" element={<PageNotFoundPage />} />
      </Route>

      {/* Mansa Liquidity — standalone layout, no admin sidebar */}
      {/* <Route
        path={appPaths.mansa}
        element={
          <RequireAuth>
            <MansaLayout />
          </RequireAuth>
        }
      >
        <Route index element={<MansaDashboard />} />
        <Route path="dashboard" element={<MansaDashboard />} />
        <Route path="requests" element={<MansaRequestsPage />} />
        <Route path="loans" element={<MansaLoansPage />} />
        <Route path="withdrawals" element={<MansaWithdrawalsPage />} />
        <Route path="repayments" element={<MansaRepaymentsPage />} />
      </Route> */}
    </Routes>
  );
}
